<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="afflictionSightingFileForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                afflictionSightingFileForm: () => import('../forms/AfflictionSightingFileForm'),
                headers: [
                    { text: 'Affliction Sighting', value: 'afflictionSightingId', table: 'afflictionSightings', form: () => import('../forms/AfflictionSightingForm') },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    afflictionSightings: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "afflictionSightingId", direction: "ascending" },
                    { column: "fileId", direction: "ascending" },
                ],
                itemsField: 'afflictionSightingFiles',
                editPageName: 'afflictionSightingFile',
                apiMethod: 'AfflictionSightingFiles',
                claimName: 'AfflictionSightingFiles',
                formTitle: 'Affliction Sighting File',
                excelTitle: 'Affliction Sighting Files',
                hasEditPage: false,
            }
        },
    };
</script>
